import { useLocation } from 'react-router';

import AdDetails from '../features/ad/components/adDetails/AdDetails';
import './styles/adBlankPage.scss';

function AdBlankPage() {
  const { search } = useLocation();

  const queryParams = new URLSearchParams(search);
  const adIdIri = queryParams.get('id') ?? null;
  return (
    <div className="body-content">
      <AdDetails adIdIri={adIdIri} />
    </div>
  );
}

export default AdBlankPage;
